import { render, staticRenderFns } from "./NetworkInfo.vue?vue&type=template&id=578eb9da&"
import script from "./NetworkInfo.vue?vue&type=script&lang=js&"
export * from "./NetworkInfo.vue?vue&type=script&lang=js&"
import style0 from "./NetworkInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports